import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

// const [data, setData] = useState('')
const initialState = {
    isLogin: false,
    contactinfo: {},
    toastData: {},
};

const homeSlice = createSlice({
    name: 'archive',
    initialState,
    reducers: {
        setContactById(state, action) {
            state.contactinfo = action.payload;
        },
        settoastData(state, action) {
            state.toastData = action.payload;
        },
    },
});

export const { settoastData, setContactById } = homeSlice.actions;

export const ContactInfoById = (id) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_URL}/journal/journalContact/${id}`).then((res) => {
        // dispatch(settoastData({ status: true, message: "You are Loged in !" }));
        dispatch(setContactById(res?.data));
        // localStorage.setItem("user", JSON.stringify(res.data))
    })
        .catch((err) => {
            dispatch(settoastData({ status: false, message: err?.response?.data }));
        })
    return response;
}
const contactinfoReducer = homeSlice.reducer;

export default contactinfoReducer;
